import { Component, OnInit, Input, TemplateRef, OnDestroy } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-main-draw',
    templateUrl: './main-draw.shared.component.html',
    styleUrls: ['./main-draw.shared.component.scss']
})
export class MainDrawComponent implements OnInit {
    @Input() public pre: TemplateRef<any> = null;
    @Input() public post: TemplateRef<any> = null;
    @Input() public background: boolean = true;
    @Input() public fullHeight: boolean = false;
    @Input() public verticalCenter: boolean = false;
    @Input() public activeHeight: boolean = true;
    @Input() public marginBottom: boolean = true;

    public isAppModeHomePage$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.isAppModeHomePage$ = this.controllers.routes.isAppModeHomePage$();
    }
}
